<template>
  <div class="laonlttlay">
    <sec-title
      Text="特推律师"
      descText="合肥律师在线咨询 ，快速解决您的法律问题"
      class="text_center"
    />
    <onadv-card />

    <!-- <view-more /> -->
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import viewMore from "views/home/components/viewMore";
import onadvCard from "../components/onadvCard";
export default {
  components: {
    secTitle,
    viewMore,
    onadvCard,
  },
  created() {
  	
  }
};
</script>

<style lang="scss" scope>
.laonlttlay {
  width: 1200px;
  margin: 0 auto;
  padding: 120px 0 50px;
}
</style>